"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BecomeCreatorButton = void 0;
const useStore_1 = require("root/src/client/logic/helpers/useStore");
const displayModal_1 = __importDefault(require("root/src/client/logic/modal/thunks/displayModal"));
const authModuleIds_1 = require("root/src/client/web/auth/descriptions/modules/authModuleIds");
const ButtonNew_1 = __importDefault(require("root/src/client/web/base/ButtonNew"));
const useBecomeCreatorButton = () => {
    const dispatch = (0, useStore_1.useAppDispatch)();
    const onBecomeCreator = () => {
        dispatch((0, displayModal_1.default)(authModuleIds_1.authModuleIds.TRANSFORM_TO_CREATOR));
    };
    return {
        onBecomeCreator,
    };
};
const BecomeCreatorButton = () => {
    const { onBecomeCreator } = useBecomeCreatorButton();
    return (<ButtonNew_1.default onClick={onBecomeCreator}>
			Become a Creator
		</ButtonNew_1.default>);
};
exports.BecomeCreatorButton = BecomeCreatorButton;
